/**
 * 本地存储工具函数
 */

/**
 * 设置localStorage
 * @param storageKey 存储键
 * @param storageValue 存储值
 */
export function setStorage(storageKey: string, storageValue: string): void {
  localStorage.setItem(storageKey, storageValue);
}

/**
 * 获取localStorage
 * @param storageKey 存储键
 * @returns 存储值或null
 */
export function getStorage(storageKey: string): string | null {
  return localStorage.getItem(storageKey);
}

/**
 * 移除localStorage项
 * @param storageKey 存储键
 */
export function removeStorage(storageKey: string): void {
  localStorage.removeItem(storageKey);
}

/**
 * 清空localStorage
 */
export function cleanLocalStorage(): void {
  localStorage.clear();
}

/**
 * 设置sessionStorage
 * @param storageKey 存储键
 * @param storageValue 存储值
 */
export function setSessionStorage(storageKey: string, storageValue: string): void {
  sessionStorage.setItem(storageKey, storageValue);
}

/**
 * 获取sessionStorage
 * @param storageKey 存储键
 * @returns 存储值或null
 */
export function getSessionStorage(storageKey: string): string | null {
  return sessionStorage.getItem(storageKey);
}

/**
 * 移除sessionStorage项
 * @param storageKey 存储键
 */
export function removeSessionStorage(storageKey: string): void {
  sessionStorage.removeItem(storageKey);
}

/**
 * 清空sessionStorage
 */
export function cleanSessionStorage(): void {
  sessionStorage.clear();
}
